import { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
const useConstituencyData=(id) =>{
  const [constituencyData, setConstituencyData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem("client-token");
       const c_id = JSON.parse(localStorage.getItem("user")).constituencyId;
       const c_type = JSON.parse(localStorage.getItem("user")).constituencyType;

       let config;
      
       if(c_type==="state")
       {
        config = {
          method: 'get',
          url: `${process.env.REACT_APP_API_URL}api/constituency/getConstituencyById/${c_id}`,
          headers: {
            'Authorization': `Bearer ${token}`
          }
        };
       }
       else if(c_type==="central"){
          config = {
          method: 'get',
          url: `${process.env.REACT_APP_API_URL}api/parliment/getParlimentById/${c_id}`,
          headers: {
            'Authorization': `Bearer ${token}`
          }
        };
       }

        const response = await axios(config);
        const data = response.data.data;
        // console.log("data",data)
        localStorage.setItem("constituencyData",JSON.stringify({data}))
        setConstituencyData(data);
        setLoading(false);
      } catch (error) {
        toast.error(error?.response?.data?.message);
        setError(error);
        setLoading(false);
      }
    };

    if (id && id !== 0) {
      fetchData();
    }
  }, [id]);
  return { loading, error, constituencyData };
}
export default useConstituencyData;